import { MemberRoute } from '/@/modules/member/routes/member.routes';
import { MembersRouteConfig } from '/@/modules/member/routes/MembersRouteConfig';

export const router = [
  MembersRouteConfig.factory({
    path: `/${MemberRoute.MEMBER.path}`,
    name: MemberRoute.MEMBER.name,
    component: () => import('/@/modules/member/pages/MembersPage.vue'),
    meta: { authOnly: true }
  }).build()
];
